import { Injectable } from '@angular/core';
import { PasswordResetUrlService } from './password-reset-url.service';
import { StorageSessionService } from '../../storage/services/storage.session.service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { HttpService } from '../../service/services/http.service';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class PasswordResetService extends HttpService {
	constructor(
		http: HttpClient,
		storageSessionService: StorageSessionService,
		router: Router,
		private passwordResetUrlService: PasswordResetUrlService
	) {
		super(http, storageSessionService, router);
	}

	resetPassword(passwordModel: any) {
		passwordModel.domain = this.passwordResetUrlService.domainName;
		return this.post(this.passwordResetUrlService.passwordResetURL + '/forgot_password', passwordModel).pipe(
			map((res) => res),
			catchError((error) => this.handleError(error))
		);
	}

	changePassword(details) {
		const reqBody = details;
		reqBody['domain'] = this.passwordResetUrlService.domainName;
		return this.post(this.passwordResetUrlService.passwordResetURL + '/reset_password', reqBody).pipe(
			map((res) => res),
			catchError((error) => this.handleError(error))
		);
	}

	verifyChangePasswordDetails(details: any) {
		const reqBody = {
			domain: this.passwordResetUrlService.domainName,
			passkey: details.passkey,
			userid: details.userid
		};
		return this.post(this.passwordResetUrlService.passwordResetURL + '/validate_userid', reqBody).pipe(
			map((res) => res),
			catchError((error) => this.handleError(error))
		);
	}
}
